import type { FC, MouseEventHandler } from "react";
import type { TextSize, TextWeight, StyledComponentAs } from "~/types";

import { StyledText } from "./StyledComponents";




interface TextProps {
  className?: string;
  size?: TextSize;
  weight?: TextWeight;
  onClick?: MouseEventHandler;
  as?: StyledComponentAs;
  "data-testid"?: string;
}

const Text: FC<TextProps> = ({
  className,
  children,
  onClick,
  size = "body",
  weight = "normal",
  as,
  "data-testid": dataTestId,
}) => (
  <StyledText
    className={className}
    as={as}
    size={size}
    weight={weight}
    onClick={onClick}
    data-testid={dataTestId}
  >
    {children}
  </StyledText>
);

export default Text;
